// src/components/StyledToggles.jsx
import { fontStyle, styled } from "@mui/system";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";

// Airport switch: Pickup/Drop
// Airport switch: Pickup/Drop
export const AirportToggle = styled(ToggleButtonGroup)(() => ({
  position: "relative",
  display: "flex",
  backgroundColor: "#E8FFF7",
  borderRadius: 12,
  boxShadow: "0 3px 7px rgba(0, 0, 0, 0.1)",

  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: 1,
    height: "100%",
    backgroundColor: "#FFFFFF",
  },
  "&::after": {
    content: '"OR"',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 24,
    height: 24,
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 10,
    fontWeight: 400,
    color: "#000",
    pointerEvents: "none",
    fontStyle: "normal",
  },
  "& .MuiToggleButtonGroup-grouped": {
    flex: 1,
    padding: "16px 16px",
    border: "none",
    borderRadius: 0,
    textTransform: "none",

    // ✅ Font style for both
    fontFamily: "Lato",
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#000000",

    // ✅ Unselected state
    fontWeight: 400,
    backgroundColor: "#E8FFF7",

    // ✅ Selected state
    "&.Mui-selected": {
      fontWeight: 700,
      backgroundColor: "#ABEDD6 !important",
    },

    "&:hover": {
      backgroundColor: "#ABEDD6 !important",
    },
  },

  // '& .MuiToggleButtonGroup-grouped': {
  //   flex: 1,
  //   padding: '12px 16px',
  //   border: 'none',
  //   borderRadius: 0,
  //   textTransform: 'none',

  //   // ✅ FONT RELATED UPDATES
  //   fontFamily: 'Lato',
  //   fontStyle: 'normal',
  //   fontWeight: 700,
  //   fontSize: '14px',
  //   lineHeight: '17px',
  //   color: '#000000',
  //   backgroundColor: 'transparent',
  //   '&.Mui-selected': {
  //     backgroundColor: '#ABEDD6',
  //   },
  //   '&:hover': {
  //     backgroundColor: '#CFFFE8',
  //   }
  // },
}));

// Plan Ahead switch: Go Now/Plan Ahead (no OR)
export const PlanToggle = styled(AirportToggle)(() => ({
  backgroundColor: "#E8FFF7",
  "&::before, &::after": { display: "none" },
}));
